import React from "react";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonModal from "../../../components/Common/CommonModal";
import CommonSelect from "../../../components/forms/CommonSelect";
import CommonTextArea from "../../../components/forms/CommonTextArea";
import {
  handleChange,
  handleChangeMultipleSelect,
} from "../../../helpers/handleFormChanges";
import CommonSelectMultiple from "../../../components/forms/CommonSelectMultiple";
import PropTypes from "prop-types";

function MensagemModal({
  isOpen,
  setIsOpen,
  valuesHook,
  colaboradores,
  canais,
  salvaMensagem,
}) {
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title={"Editar mensagem"}
      is_open_modal={isOpen}
      set_is_open_modal={setIsOpen}
      size="lg"
      buttons={
        <CommonButton
          key={`salvar-mensagem`}
          onClick={() => {
            salvaMensagem();
          }}
          color="success"
        >
          Salvar
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonSelectMultiple
            label="Colaboradores"
            id="colaborador"
            data={colaboradores}
            value={values?.colaborador
              ?.map((id) =>
                colaboradores.find((colaborador) => colaborador.codigo === id)
              )
              .filter(Boolean)}
            onChange={(e, newValue) => {
              handleChangeMultipleSelect(
                values,
                setValues,
                "colaborador",
                newValue,
                "codigo"
              );
            }}
            groupBy="grupo"
            optionLabel="nome"
            optionValue="codigo"
            required
          />
        </div>
        <div className="col-md-6 mb-3">
          <CommonSelect
            label="Canal"
            id="canal"
            value={values.canal}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            data={
              canais &&
              canais.map((canal) => ({
                text: canal.nome,
                id: canal.link,
              }))
            }
            placeholder="Selecione um canal"
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 mb-3">
          <CommonTextArea
            label="Mensagem"
            id="mensagem"
            value={values.mensagem}
            rows={11}
            disabled
          />
        </div>
      </div>
    </CommonModal>
  );
}

MensagemModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  colaboradores: PropTypes.arrayOf(PropTypes.object).isRequired,
  canais: PropTypes.arrayOf(PropTypes.object).isRequired,
  salvaMensagem: PropTypes.func.isRequired,
};

export default MensagemModal;
